export default __webpack_public_path__ + "static/media/gauntlets_of_the_vanguard.8d089854.jpg";